<template>
  <v-card class="oderon-card elevation-0">
    <RowDetailsDialog ref="detailsDialog" />

    <v-toolbar>
      <v-toolbar-title>
        Estoque
        <span v-if="row.depot != null"> : {{ row.depot.name }} </span>
      </v-toolbar-title>

      <v-btn icon class="ml-4" @click="reload">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>

      <OSelectColsButton :fullSpec="fullSpec" v-model="vars" />

      <v-spacer />

      <!-- <v-btn icon @click="checkDownload" title="Exportar para Excel">
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn> -->
    </v-toolbar>

    <OLoadingLine absolute :value="isLoading" />

    <OJumbo v-if="row.depotId == null" question>
      Este técnico não está associado a um estoque.
    </OJumbo>

    <OJumbo v-else-if="gridData == null" loading>
      Carregando dados...
    </OJumbo>

    <OJumbo v-else-if="gridData.rows.length < 1" question>
      Não foram encontrados dados para o filtro informado.
    </OJumbo>

    <ODataGrid
      v-else
      class="maxh-full-4"
      :data="gridData"
      :limit.sync="limit"
      :offset.sync="offset"
      :order.sync="order"
      @rowClicked="showRowDetails"
    />
  </v-card>
</template>

<script>
import { InstalledBase } from '@/models'
import ODataGrid from 'oderon-vue/cpts/ODataGrid'
import OSelectColsButton from 'oderon-vue/cpts/OSelectColsButton'
import PaginatedReportMixin from 'oderon-vue/cpts/PaginatedReportMixin'
import RowDetailsDialog from '@/views/installed-base/RowDetailsDialog.vue'
import utils from 'oderon-commons/src/utils'

export default {
  mixins: [PaginatedReportMixin],
  components: { ODataGrid, OSelectColsButton, RowDetailsDialog },
  props: {
    row: { required: true }
  },
  data() {
    return {
      isLoading: false,
      vars: [],
      offset: 0,
      limit: 5,
      order: 'clientId asc',
      fullSpec: null,
      gridData: null
    }
  },
  computed: {
    filterParams() {
      return {
        depotIds: this.row.depotId
      }
    },
    apiParams() {
      return utils.clearEmptyValues({
        ...this.filterParams,
        vars: this.vars,
        offset: this.offset,
        limit: this.limit,
        order: this.order
      })
    }
  },
  mounted() {
    this.reload()
  },

  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      if (this.fullSpec == null) {
        this.fullSpec = await InstalledBase.getGridSpec()
      }

      if (this.row.depotId == null) {
        this.gridData = null
      } else {
        this.gridData = await InstalledBase.getGrid(this.apiParams)
      }
    },

    async showRowDetails(row, idx, isMiddle) {
      this.$loading(async () => {
        let id = row.id,
          [clientId, vehicleId] = id.split(':')

        if (isMiddle) {
          let url = `/clients/${clientId}`
          if (utils.isEmpty(clientId)) {
            let orgId = Math.floor(+vehicleId / 10000)
            let idInOrg = +vehicleId % 10000
            url = `/vehicles/${orgId}/${idInOrg}`
          }

          window.open(`/#${url}`, '_blank')
        } else {
          this.$refs.detailsDialog.open(id)
        }
      })
    }
  }
}
</script>

<style></style>